<template>
    <v-app>
        <v-container fluid>
            <v-row v-if="$insertAccess($route.path)">
                <v-col cols="12">
                    <v-form @submit.prevent="submit" ref="addEmployee" id="addEmployee">

                        <v-row>
                            <v-col cols="12">
                                <v-card class="">
                                    <v-card-title class="text-subtitle-1 bg-blue-grey-lighten-4 mb-0 pa-1">
                                        <v-icon class="me-1" size="small">mdi-trending-up</v-icon>
                                        Lead Details
                                    </v-card-title>

                                    <v-card-text class="pa-1"> 
                                            
                                        <v-row class="ma-0">
                                            <v-col md="3" cols="12" class="pa-1">
                                                <v-date-input
                                                    input-format="dd/mm/yyyy"
                                                    prepend-icon=""
                                                    prepend-inner-icon="mdi-calendar"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="white"
                                                    v-model="lead_date.value.value"
                                                    :error-messages="lead_date.errorMessage.value"
                                                    autocomplete="off"
                                                    clearable
                                                >
                                                    <template #label>
                                                        Create Date
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-date-input>
                                            </v-col>

                                            <v-col cols="12" sm="4" md="3" class="pa-1">
                                                <v-autocomplete
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="white"
                                                    v-model="lead_source_type_id.value.value"
                                                    :items="getSalesLeadTypes"
                                                    :item-title="(item) => `${item.name}`"
                                                    item-value="id"
                                                    :error-messages="lead_source_type_id.errorMessage.value"
                                                    autocomplete="off"
                                                    clearable
                                                
                                                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                    <template #label>
                                                        Source Type
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-autocomplete>
                                            </v-col>

                                            <v-col cols="12" sm="4" md="3" class="pa-1">
                                                <v-autocomplete
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="white"
                                                    v-model="lead_by_employee_id.value.value"
                                                    :items="getHrmEmployeeList"
                                                    :item-title="(item) => `${item.code}-${item.name}`"
                                                    item-value="id"
                                                    :error-messages="lead_by_employee_id.errorMessage.value"
                                                    autocomplete="off"
                                                    clearable
                                                
                                                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                    <template #label>
                                                        Lead By
                                                        <span class="text-red-accent-4"></span>
                                                    </template>
                                                </v-autocomplete>
                                            </v-col>

                                            <v-col cols="12" sm="4" md="3" class="pa-1" >
                                                <v-date-input
                                                    input-format="dd/mm/yyyy"
                                                    prepend-icon=""
                                                    prepend-inner-icon="mdi-calendar"
                                                    label="Follow up date"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="white"
                                                    v-model="follow_up_date.value.value"
                                                    :disabled="!isEntryMode"
                                                    :error-messages="follow_up_date.errorMessage.value"
                                                    autocomplete="off"
                                                    clearable
                                                >
                                                </v-date-input>
                                            </v-col>

                                            <v-col cols="12" sm="4" md="3" class="pa-1">
                                                <v-date-input   
                                                    input-format="dd/mm/yyyy"
                                                    prepend-icon=""
                                                    prepend-inner-icon="mdi-calendar"
                                                    label="Next Follow up date"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="white"
                                                    v-model="next_follow_up_date.value.value"
                                                    :disabled="!isEntryMode"
                                                    :error-messages="next_follow_up_date.errorMessage.value"
                                                    autocomplete="off"
                                                    clearable
                                                ></v-date-input>   
                                            </v-col>
                                        </v-row>
                                        </v-card-text>
                                </v-card>
                            </v-col>

                            <v-col cols="12">
                                <v-card>
                                    <v-card-title class="text-subtitle-1 bg-blue-grey-lighten-4 mb-0 pa-1">
                                        <v-icon class="me-1" size="small">mdi-domain</v-icon>
                                        Company Details 
                                    </v-card-title>

                                     <v-card-text class="pa-2"> 
                                            
                                        <v-row class="ma-0">

                                            <v-col cols="12" sm="4" md="3" class="pa-1">
                                                <v-autocomplete
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="white"
                                                    v-model="market_id.value.value"
                                                    :items="getMarketList"
                                                    :item-title="(item) => `${item.code}-${item.name}`"
                                                    item-value="id"
                                                    :error-messages="market_id.errorMessage.value"
                                                    autocomplete="off"
                                                    clearable
                                                
                                                    :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                    <template #label>
                                                        Market Name
                                                        <span class="text-red-accent-4"></span>
                                                    </template>
                                                </v-autocomplete>
                                            </v-col>

                                            <v-col cols="12" md="3" class="pa-1">
                                                <v-text-field
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="white"
                                                    v-model="company_name.value.value"
                                                    :error-messages="company_name.errorMessage.value"
                                                    autocomplete="off"
                                                    clearable
                                                >
                                                    <template #label>
                                                        Company Name
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-text-field>    

                                            </v-col>
                                            <v-col cols="12" md="3" class="pa-1">
                                                <v-text-field
                                                    label="Company Mobile no."
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="white"
                                                    v-model="company_phone.value.value"
                                                    :error-messages="company_phone.errorMessage.value"
                                                    autocomplete="off"
                                                    clearable
                                                >
                                                    <template #label>
                                                        Company Mobile no.
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-text-field>
                                            </v-col>
                                                
                                            <v-col cols="12" md="3" class="pa-1">
                                                <v-text-field
                                                    label="Company Nature of Business"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="white"
                                                    v-model="company_nature_of_business.value.value"
                                                    :error-messages="company_nature_of_business.errorMessage.value"
                                                    autocomplete="off"
                                                    clearable
                                                >
                                                </v-text-field>
                                            </v-col>
                                                    
                                            <v-col cols="12" md="3" class="pa-1">
                                                    <v-textarea
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="white"
                                                    v-model="company_address.value.value"
                                                    :error-messages="company_address.errorMessage.value"
                                                    autocomplete="off"
                                                    rows="1"
                                                    clearable
                                                >
                                                    <template #label>
                                                        Company Address
                                                        <span class="text-red-accent-4"></span>
                                                    </template>
                                                </v-textarea>
                                            </v-col>
                                            
                                        </v-row>  
                                    </v-card-text>
                                </v-card>
                            </v-col>

                            <!-- Customer -->
                            <v-col cols="12">
                                <v-card>
                                    <v-card-title class="text-subtitle-1 bg-blue-grey-lighten-4 mb-0 pa-1">
                                        <v-icon class="me-1" size="small">mdi-account</v-icon>
                                        Customer Information
                                    </v-card-title>

                                    <v-divider></v-divider>
                                    <v-card-text>
                                        <v-row>
                                            <v-col cols="12" sm="4" md="3" class="px-2 pa-0 pt-1">
                                                <v-text-field
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="white"
                                                    v-model="contact_name.value.value"
                                                    :error-messages="contact_name.errorMessage.value"
                                                    autocomplete="off"
                                                    clearable
                                                >
                                                    <template #label>
                                                        Contact Person Name
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-text-field>
                                            </v-col>
            
                                            <v-col cols="12" sm="4" md="3" class="px-2 pa-0 pt-1">
                                                <v-text-field
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="white"
                                                    v-model="contact_email.value.value"
                                                    :error-messages="contact_email.errorMessage.value"
                                                    autocomplete="off"
                                                    clearable
                                                >
                                                    <template #label>
                                                        Contact person Email
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-text-field> 
                                            </v-col>
            
                                            <v-col cols="12" sm="4" md="3" class="px-2 pa-0 pt-1">
                                                <v-text-field
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="white"
                                                    v-model="contact_number.value.value"
                                                    :error-messages="contact_number.errorMessage.value"
                                                    autocomplete="off"
                                                    clearable
                                                >
                                                    <template #label>
                                                        Contact person Mobile No
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-text-field>
                                            </v-col>
            
                                            <v-col cols="12" sm="4" md="3" class="px-2 pa-0 pt-1">
                                                <v-text-field
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="white"
                                                    v-model="contact_designation.value.value"
                                                    :error-messages="contact_designation.errorMessage.value"
                                                    autocomplete="off"
                                                    clearable
                                                >
                                                    <template #label>
                                                        Contact person Designation
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                </v-text-field>
                                            </v-col>

                                            <v-col cols="12" sm="4" md="3" class="px-2 pa-0 pt-1">
                                                <v-text-field
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="white"
                                                    v-model="widget_id_no.value.value"
                                                    :error-messages="widget_id_no.errorMessage.value"
                                                    autocomplete="off"
                                                    clearable
                                                >
                                                    <template #label>
                                                        Widget ID
                                                        <span class="text-red-accent-4"></span>
                                                    </template>
                                                </v-text-field>
                                            </v-col>

                                            <v-col cols="12" sm="4" md="3" class="px-2 pa-0 pt-1">
                                                <v-text-field
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="white"
                                                    v-model="widget_group.value.value"
                                                    :error-messages="widget_group.errorMessage.value"
                                                    autocomplete="off"
                                                    clearable
                                                >
                                                    <template #label>
                                                        Widget Group
                                                        <span class="text-red-accent-4"></span>
                                                    </template>
                                                </v-text-field>
                                            </v-col>

                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                                
                        <v-row class="d-flex justify-end px-5 mt-2">
                            <v-checkbox
                                :true-value="1"
                                :false-value="0"
                                v-model="status.value.value"
                                label="Active"
                                color="primary"
                            ></v-checkbox>  
                        </v-row>
                        <input v-model="lead_master_id.value.value" type="hidden">

                        <v-card>
                            <v-card-actions>
                                <v-layout class="justify-end">
                                    <v-btn class="bg-red" variant="flat" type="reset">Reset</v-btn>
                                    <v-btn 
                                        class="bg-brand w-15 ms-2"  
                                        variant="flat" 
                                        type="submit"   
                                        @click="submit"
                                    >
                                        {{ buttonText }}
                                    </v-btn>
                                </v-layout>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>

import {useStore} from 'vuex';
import { useField, useForm } from 'vee-validate';
import * as yup from 'yup';
import { ref, watch } from 'vue';
import { toast } from 'vue3-toastify';
import formattedDate from '@/plugins/dateFormatter';
import { useRouter, useRoute } from 'vue-router';

export default {
    components: {
    },
    data: () => ({
        panel: [0],
        panel1: [0],
        panel2: [0],
        panel3: [0],
        loading:false,
        errorMessages:'',
        isEntryMode: true,
        visible: false,
        search: "",
        selectedImage: null,
        photo_imageFile:'',
        preview: '/src/assets/no_preview.png',
    }),
    watch: {
    },
    created(){
        // if (this.$store.getters.getInvCountryList.length === 0) {
            this.$store.dispatch('getInvCountryList');
        // }

        // if(this.$store.getters.getHrmDesignationList.length === 0) {
            this.$store.dispatch('getHrmDesignationList');
        // }

        // if(this.$store.getters.getSalesLeads.length === 0) {
            this.$store.dispatch('getSalesLeads');
        // }

        // if(this.$store.getters.getSalesLeadTypes.length === 0) {
            this.$store.dispatch('getSalesLeadTypes');
        // }

        // if(this.$store.getters.getHrmEmployeeList.length === 0) {
            this.$store.dispatch('getHrmEmployeeList');
        // }

        // if(this.$store.getters.getSalesLeadStatus.length === 0) {
            this.$store.dispatch('getSalesLeadStatus');
        // }

        // if(this.$store.getters.getMarketList.length === 0) {
            this.$store.dispatch('getMarketList');
        // }
    },
    computed:{
        getInvCountryList() {
            console.log(this.$store.getters.getInvCountryList)
            return this.$store.getters.getInvCountryList;
        },
        getHrmDesignationList() {
            return this.$store.getters.getHrmDesignationList;
        },
        getSalesLeads() {
            return this.$store.getters.getSalesLeads;
        },
        getSalesLeadTypes() {
            return this.$store.getters.getSalesLeadTypes;
        },
        getHrmEmployeeList(){
            return this.$store.getters.getHrmEmployeeList;
        },
        getMarketList(){
            return this.$store.getters.getMarketList;
        },
        getSalesLeadStatus() {
            return this.$store.getters.getSalesLeadStatus;
        },
    },
    methods: {
        editItem(item){
            this.buttonText = 'Update';
            this.status.value.value = item.status;
            this.lead_master_id.value.value = item.id;
        },
    },
    setup() {
        const { handleSubmit, resetForm} = useForm({
            validationSchema: yup.object({
                lead_date: yup.string().required().label('Create Date'),
                company_name: yup.string().min(3).max(70).required().trim().label('Company Name'),
                company_phone: yup.string().trim().min(7).max(15).required().label('Company Mobile No'),
                company_address: yup.string().min(3).max(250).nullable().trim().label('Company Address'),
                company_nature_of_business: yup.string().min(3).max(50).nullable().trim().label('Company Nature of Business'),
                contact_name: yup.string().min(3).max(50).required().trim().label('Contact Person Name'),
                contact_email: yup.string().min(3).max(50).required().trim().email().label('Contact Person Email'),
                contact_number: yup.string().trim().min(7).max(15).nullable().label('Contact Person Mobile No'),
                contact_designation: yup.string().required().label('Company Person Designation'),
                widget_id_no:yup.string().nullable().label('Widget ID'),
                widget_group:yup.string().nullable().label('Widget Group'),
                lead_source_type_id: yup.string().required().label('Lead Source Type'),
                lead_by_employee_id: yup.string().nullable().label('Lead By'),
                market_id: yup.string().nullable().label('Market'),
                follow_up_date: yup.string().nullable().label('Follow up date'),
                next_follow_up_date: yup.string().nullable().label('Next Follow up date'),
                status: yup.number().nullable().label('Active'),

            }),

        });

        const lead_date = useField('lead_date');
        const company_name = useField('company_name');
        const company_phone = useField('company_phone');
        const company_address = useField('company_address');
        const company_nature_of_business = useField('company_nature_of_business');
        const contact_name = useField('contact_name');
        const contact_email = useField('contact_email');
        const contact_number = useField('contact_number');
        const contact_designation = useField('contact_designation');
        const widget_id_no = useField('widget_id_no');
        const widget_group = useField('widget_group');
        const lead_source_type_id = useField('lead_source_type_id');
        const lead_by_employee_id  = useField('lead_by_employee_id');
        const market_id = useField('market_id');
        const follow_up_date = useField('follow_up_date');
        const next_follow_up_date = useField('next_follow_up_date');
        // const lead_interest_id = useField('lead_interest_id');
        // const lead_action_id = useField('lead_action_id');
        const status = useField('status');
        const lead_master_id = useField('lead_master_id')
        const errorMessages = ref('');
        const loading  = ref('');
        const buttonText  = ref('');
        buttonText.value = 'Save';
        const store = useStore();
        const router = useRouter();
        status.value.value = 0;
        
        const submit = handleSubmit((values) => {
            values.follow_up_date = formattedDate(follow_up_date.value.value);
            values.next_follow_up_date = formattedDate(next_follow_up_date.value.value);
            values.lead_date = formattedDate(lead_date.value.value);
            // Create a FormData object
            const formData = new FormData();
            // Append all form values to FormData
            Object.keys(values).forEach((key) => { formData.append(key, values[key] || "");});
            store.dispatch("saveUpdateSalesLeads", formData, { headers: { 'Content-Type': 'multipart/form-data' } })
                .then((response) => {
                    resetForm();
                    buttonText.value = 'Save';
                    toast.success(response.data.message, {
                        timeout: 3000,
                    });
                    setTimeout(() => {
                        router.push({ path: "crm-lead-record-v2" });
                    }, 2000);
                })
                .catch((error) => {            
                    toast.error(error.response.data.message);          
                })
        });
        
        return {
            submit,
            lead_date,
            company_name,
            company_phone,
            company_address,
            company_nature_of_business,
            contact_name,
            contact_email,
            contact_number,
            contact_designation,
            widget_id_no,
            widget_group,
            lead_source_type_id,
            lead_by_employee_id,
            market_id,
            follow_up_date,
            next_follow_up_date,
            // lead_interest_id,
            status,
            resetForm,
            // lead_action_id,
            lead_master_id,
            errorMessages,
            buttonText,
            loading
        }
    },
    mounted() {
        const queryId = this.$route.query.id;
        if (this.$store.getters.getEditingSalesLeads && queryId) {
            const leads = this.$store.getters.getEditingSalesLeads;
            this.isEntryMode = false;
            this.lead_master_id.value.value = leads.id,
            this.market_id.value.value = leads.market_id,
            this.lead_by_employee_id.value.value = leads.lead_by_employee_id,
            this.lead_date.value.value = leads.lead_date,
            this.company_name.value.value = leads.company_name
            this.company_phone.value.value = leads.company_phone,
            this.company_address.value.value = leads.company_address,
            this.company_nature_of_business.value.value = leads.company_nature_of_business,
            this.contact_name.value.value = leads.contact_name,
            this.contact_email.value.value = leads.contact_email,
            this.contact_number.value.value = leads.contact_number,
            this.contact_designation.value.value = leads.contact_designation,
            this.lead_source_type_id.value.value = leads.lead_source_type_id,
            this.follow_up_date.value.value = leads.follow_up_date,
            this.next_follow_up_date.value.value = leads.next_follow_up_date,
            this.widget_id_no.value.value = leads.widget_id_no,
            this.widget_group.value.value = leads.widget_group,
            // this.lead_interest_id.value.value = leads.lead_interest_id,
            this.status.value.value = leads.status===1? 1: 0,
            // this.lead_action_id.value.value = leads.lead_action_id,
            this.buttonText = 'Update'
        } else {
            this.$store.commit("setEditingSalesLeads", null);
            this.isEntryMode = true;
            this.resetForm();
        }
    }  
}

</script>

<style scoped>
.v-card-title {
    height: 40px;
    display: flex;
    align-items: center;
    font-size: 18px;
}
</style>


